import React from "react";
import PropTypes from "prop-types";
import useInputBehaviour from "./useInputBehaviour";
const InputContext = /*#__PURE__*/React.createContext({});
const InputBehaviour = ({
  children
}) => {
  const contextValue = useInputBehaviour();
  return /*#__PURE__*/React.createElement(InputContext.Provider, {
    value: {
      ...contextValue
    }
  }, children);
};
export { InputContext, InputBehaviour };